import { Component } from "@angular/core";

@Component({
    selector: "app-deductible",
    template: "<router-outlet></router-outlet>",
})
export class DeductibleComponent { }



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/deductible/deductible.component.ts